export enum CSVFormat {
  CustomBreaks = 'Custom (Breaks)',
  CustomSpins = 'Custom (Spins)',
  Hawkeye = 'Hawkeye',
  Statcast = 'Statcast',
  Unknown = 'Unknown',
}
